module.exports = __webpack_public_path__ + "img/Hong Kong.c140d464.svg";